import { Grid, MenuItem, TextField, useTheme } from '@mui/material';
import '../../../services/apiTypes';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  setAnswer,
  setQuestionMemo,
} from '../../../stores/confirmedInspection/slice';
import { Question } from '../../../services/apiTypes';
import { ANSWER_VALUE } from '../../../_constants/Const';
import { MaxLength } from '../../../_constants/maxLengthConst';

type QuestionProps = {
  questions: Question[];
};

const questionText = [
  'a) Has the Product caused or contributed to a death or a Serious Injury, or does the event reasonably suggest that the Product may have caused contributed to a death or Serious Injury?',
  'b) Does the event reasonably suggest that the Product Malfunctioned and that the Product or a similar FUJIFILM device would be likely to cause or contribute to a death or Serious Injury if the Malfunction were to recur?',
  'c) Has an electrical, mechanical, or chemical hazard including, but not limited to, smoke, fire, electric shock, burn, etc., been associated with use of the Product?',
];

const QuestionComponent: React.FC<QuestionProps> = ({ questions }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  return (
    <Grid
      container
      size={12}
      spacing={1}
      sx={{
        backgroundColor: '#F2F2F2',
        margin: '20px',
        borderRadius: '4px',
      }}
    >
      <Grid sx={{ backgroundColor: '#FFF', margin: '20px', width: '100%' }}>
        {questions.map((item, index) => (
          <Grid
            key={`question_${index}`}
            container
            spacing={2}
            sx={{ backgroundColor: '#FFF', margin: '20px' }}
            style={{
              borderBottom: 'solid 1px',
              margin: '0 0 0 5px',
              borderColor: '#c0c0c0',
            }}
            size={12}
          >
            <Grid
              size={8.5}
              style={{
                padding: '10px 0 0 10px',
              }}
            >
              {questionText[index]}
            </Grid>
            <Grid
              sx={{ padding: '10px 0 0 10px', textAlign: 'right' }}
              size={1.5}
            >
              <TextField
                id={`question_${index}`}
                select
                size="small"
                sx={{
                  bgcolor: 'warning.light',
                  width: '60%',
                  textAlign: 'left',
                  minWidth: '70px',
                }}
                value={String(item.answer)}
              >
                <MenuItem
                  value={ANSWER_VALUE.YES}
                  onClick={() =>
                    dispatch(setAnswer({ id: index, answer: ANSWER_VALUE.YES }))
                  }
                >
                  Yes
                </MenuItem>
                <MenuItem
                  value={ANSWER_VALUE.NO}
                  onClick={() =>
                    dispatch(setAnswer({ id: index, answer: ANSWER_VALUE.NO }))
                  }
                >
                  No
                </MenuItem>
              </TextField>
            </Grid>
            <Grid sx={{ padding: '10px' }} size={2}>
              <TextField
                id={`question_text_${index}`}
                variant="outlined"
                fullWidth
                size="small"
                sx={{
                  bgcolor: 'background.paper',
                  '&:placeholder-shown': {
                    bgcolor: theme.palette.background.default,
                  },
                }}
                key={`question_memo_${index}`}
                defaultValue={item.memo}
                onBlur={(event) =>
                  dispatch(
                    setQuestionMemo({ id: index, memo: event.target.value }),
                  )
                }
                slotProps={{
                  htmlInput: {
                    maxLength: MaxLength.ConfirmedInspection.QUESTION_TEXT,
                  },
                }}
              />
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default QuestionComponent;
